/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __importDefault(require("axios"));

var querystring_1 = __importDefault(require("querystring"));

var Api = /*#__PURE__*/function () {
  function Api() {
    var _this = this;

    _classCallCheck(this, Api);

    this.HEADERS = {
      'Content-Type': 'text/plain'
    };
    this.configuration = {
      GET: function GET(code) {
        var url = "".concat(_this.apiRoot, "configuration/").concat(code);
        return axios_1.default.get(url);
      },
      POST: function POST(configuration, model, _ref) {
        var attributes = _ref.attributes,
            countryCode = _ref.countryCode,
            price = _ref.price,
            properties = _ref.properties;
        var url = "".concat(_this.apiRoot, "configuration");
        var ts = Date.now();
        var payload = {
          modelId: model.id,
          attributes: attributes,
          configuration: configuration,
          countryCode: countryCode,
          price: price,
          properties: properties,
          ts: ts
        };
        return axios_1.default.post(url, payload, {
          headers: _this.HEADERS
        });
      }
    };
    this.custom = {
      GET: function GET(endpoint, queryParams) {
        var url = "".concat(_this.apiRoot).concat(endpoint);

        if (queryParams) {
          url += "?".concat(querystring_1.default.stringify(queryParams));
        }

        return axios_1.default.get(url);
      }
    };
    this.dealer = {
      GET: function GET(zipcode) {
        var url = "".concat(_this.apiRoot, "dealer/").concat(zipcode);
        return axios_1.default.get(url);
      }
    };
    this.email = {
      POST: function POST(payload) {
        var url = "".concat(_this.apiRoot, "mail");
        return axios_1.default.post(url, payload, {
          headers: _this.HEADERS
        });
      }
    };
    this.lead = {
      POST: function POST(payload) {
        var url = "".concat(_this.apiRoot, "lead");
        return axios_1.default.post(url, payload, {
          headers: _this.HEADERS
        });
      }
    };
    this.pdf = {
      GET: function GET() {
        var configurationId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'new';
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var url = "".concat(_this.apiRoot, "pdf/").concat(configurationId);
        return axios_1.default.get(url, {
          params: params
        });
      }
    };
  }

  _createClass(Api, [{
    key: "init",
    value: function init(env) {
      this.apiRoot = env.BRIGHTSMITH_API_ROOT;
    }
  }]);

  return Api;
}();

var instance = new Api();
exports.default = instance;